import React from 'react';
import {Glyphicon} from 'react-bootstrap';
import noPhoto from '../../../assets/img/imperial_tobacco.png';
import './style.css';

const ProductImage = ({
  image = noPhoto, div = false, labels = {
    inBasket: false,
    featured: false,
    reward: false,
    new: false
  }
}) => {
  const renderStateLabels = () => {
    const renderedLabels = [];

    if (labels.reward === true) {
      renderedLabels.push((
        <div className="corner-label top-left" key="reward-label">
          <div className="corner-icon">
            <Glyphicon glyph="gift"/>
            <span className="icon-label">
              REWARD
            </span>
          </div>
        </div>
      ));
    }
    if (labels.inBasket === true) {
      renderedLabels.push((
        <div className="corner-label bottom-right" key="in-basket-label">
          <div className="corner-icon success">
            <Glyphicon glyph="ok"/>
          </div>
        </div>
      ));
    }
    if (labels.featured === true) {
      renderedLabels.push((
        <div className="corner-label bottom-left" key="featured-label">
          <div className="corner-icon">
            <Glyphicon glyph="star"/>
            <span className="icon-label">
              FEATURED
            </span>
          </div>
        </div>
      ));
    }
    if (labels.new === true) {
      renderedLabels.push((
        <div className="corner-label top-right" key="new-label">
          <div className="corner-icon">
            <Glyphicon glyph="tags"/>
            <span className="icon-label">
              NEW
            </span>
          </div>
        </div>
      ));
    }

    return renderedLabels;
  };

  return (
    <div className="product-image-container">
      <div className="product-image-wrapper">

        {div ? <div className="product-image-div" style={{backgroundImage: `url(${image})`}}/> :
        <img alt="Product" className="product-image" src={image}/>
        }
      </div>

      {renderStateLabels()}

    </div>
  );
};

export default ProductImage;



// WEBPACK FOOTER //
// ./src/components/common/product/product-image.jsx